import { render, staticRenderFns } from "./AccessView.vue?vue&type=template&id=464a4b3e&scoped=true&"
import script from "./AccessView.vue?vue&type=script&lang=js&"
export * from "./AccessView.vue?vue&type=script&lang=js&"
import style0 from "./AccessView.vue?vue&type=style&index=0&id=464a4b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a4b3e",
  null
  
)

export default component.exports